export default {
  components: {
    styleOverrides: {
      root: {
        '&.MuiContainer-root': {
          padding: 0
        }
      }
    }
  }
};
